import { arrayToObject } from '@hotglue/common';

const defaultState = {
  supported: {},
  linked: undefined,
  linkedList: [],
  selectedSource: undefined,
  selectedStream: undefined,
  fieldMapSelection: undefined,
  status: undefined,
  primaryKeys: []
};

export default (state = defaultState, action) => {
  let newState = Object.assign({}, state);
  const { payload, status, type, params } = action;

  switch (type) {
    case 'SET_SOURCE_PRIMARY_KEYS':
      newState.primaryKeys = payload;
      return newState;
    case 'SELECT_STREAM':
      newState.selectedStream = payload;
      return newState;
    case 'SET_FIELD_MAP':
      const { tap } = params;
      if (params.stream) {
        const { stream } = params;
        newState.linked[tap].fieldMap[stream] = payload;
        return newState;
      }

      newState.linked[tap].fieldMap = payload;
      return newState;
    case 'UPDATE_LINKED_SOURCE':
      if (status == 'error') newState.error = 'error';
      if (status == 'success') {
        const { tap, fieldMap } = params;

        if (fieldMap) newState.linked[tap] = { ...newState.linked[tap], fieldMap };
      }

      return newState;
    case 'SET_TENANT':
    case 'CLEAR_SOURCES':
      newState.linked = undefined;
      newState.selectedSource = undefined;
      newState.selectedStream = undefined;
      return newState;

    case 'FETCH_SUPPORTED_SOURCES':
      const { flowId } = params;
      if (status == 'success') newState.supported[flowId] = arrayToObject(payload, 'tap');
      return newState;

    case 'FETCH_LINKED_SOURCES':
      newState.status = status;
      if (status == 'success') {
        const multipleTenantLinks = params?.multipleTenantLinks ?? false;
        const subtenantDelimiter = params?.subtenantDelimiter ?? '_';
        const filteredPayload = params?.tenant
          ? payload.filter((source) => {
              return multipleTenantLinks && !params?.tenant.includes(subtenantDelimiter)
                ? (source.tenant_id ?? '').startsWith(params?.tenant)
                : source.tenant_id === params?.tenant;
            })
          : payload;
        newState.linked = arrayToObject(filteredPayload, 'tap');
        newState.linkedList = payload;
      }
      return newState;

    case 'ADD_LINKED_SOURCE':
      if (status == 'success' && params.source) newState.linked = { [params.source.tap]: params.source };
      return newState;

    case 'FETCH_LINKED_SOURCE':
      newState.status = status;
      if (status == 'success') {
        newState.linked = arrayToObject(payload, 'tap');
        if (newState.linkedList.length > 0 && payload.length === 1) {
          const index = newState.linkedList.findIndex((x) => x.tenant_id === payload[0].tenant_id && x.tap === payload[0].tap);
          if (index >= 0) newState.linkedList[index] = payload[0];
        } else {
          newState.linkedList = payload;
        }
      }
      return newState;

    case 'SELECT_SOURCE':
      newState.selectedSource = payload;
      return newState;
    case 'SET_FIELD_MAP_SELECTION':
      const { stream } = params;
      if (stream) newState.fieldMapSelection[stream] = { ...newState.fieldMapSelection[stream], ...payload };
      else newState.fieldMapSelection = payload;
      return newState;
    case 'CLEAR_FIELD_MAP_SELECTION':
      newState.fieldMapSelection = undefined;
      return newState;
  }

  return state;
};
